/*----------------------------------------
Sub-optimal browser detection */

import constants from 'lib/constants';
import cookies from 'cookies-js';

export function detect(){
	var ds = document.documentElement.style;

	// set the sub-optimal cookie when user enters from sub-optimal page
	if(window.location.hash === '#suboptimal' || window.location.hash === '#/suboptimal') {
		cookies.set(constants.subOptimalCookie, 'false', { expires: Infinity });
	}

	// detect if the browser supports flex
	if(navigator.appVersion.indexOf('MSIE 10') !== -1 || ('flex' in ds) == null || ('WebkitFlex' in ds) == null || ('msFlex' in ds) == null){

		// grab the suboptimal cookie if it exists
		var coe = cookies.get(constants.subOptimalCookie);

		// if suboptimal cookie does not exist, redirect user to suboptimal site
		if(!coe){
			var currPath = window.location.href;
			window.location.replace(constants.subOptimalUrl + '?resource=' + encodeURIComponent(currPath));
		}
	}
}

var returnVal = {
	detect: detect
};

export default returnVal;
